import { render } from "./gridNav.vue?vue&type=template&id=12b4852a"
import script from "./gridNav.vue?vue&type=script&lang=js"
export * from "./gridNav.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__